export const GO_TO_LOGIN = 'GO_TO_LOGIN';
